import type { IconSvgProps } from '../Icon.types';

export const CrossSimple = ({ fill, width, height, className }: IconSvgProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    
  >
    <path
      d="M25.5301 24.47C25.6038 24.5386 25.6629 24.6214 25.7039 24.7134C25.7449 24.8054 25.7669 24.9047 25.7687 25.0054C25.7705 25.1061 25.7519 25.2062 25.7142 25.2996C25.6765 25.393 25.6203 25.4778 25.5491 25.549C25.4779 25.6202 25.3931 25.6764 25.2997 25.7141C25.2063 25.7518 25.1063 25.7703 25.0056 25.7686C24.9049 25.7668 24.8056 25.7447 24.7136 25.7038C24.6216 25.6628 24.5388 25.6037 24.4701 25.53L16.0001 17.0612L7.53009 25.53C7.38792 25.6625 7.19987 25.7346 7.00557 25.7311C6.81127 25.7277 6.62588 25.649 6.48847 25.5116C6.35106 25.3742 6.27234 25.1888 6.26892 24.9945C6.26549 24.8002 6.33761 24.6121 6.47009 24.47L14.9388 16L6.47009 7.52997C6.33761 7.38779 6.26549 7.19975 6.26892 7.00545C6.27234 6.81114 6.35106 6.62576 6.48847 6.48835C6.62588 6.35093 6.81127 6.27222 7.00557 6.26879C7.19987 6.26537 7.38792 6.33749 7.53009 6.46997L16.0001 14.9387L24.4701 6.46997C24.6123 6.33749 24.8003 6.26537 24.9946 6.26879C25.1889 6.27222 25.3743 6.35093 25.5117 6.48835C25.6491 6.62576 25.7278 6.81114 25.7313 7.00545C25.7347 7.19975 25.6626 7.38779 25.5301 7.52997L17.0613 16L25.5301 24.47Z"
      fill={fill}
    />
  </svg>
);
